import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
  mb: 0.5,
};
